import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import UserMenu from '../UserMenu';
import Search from './Search';
import {
  InputContainer,
  BackButtonIcon,
  BackButton,
  Container,
  LogoJunto,
  SelectStatus
} from './styles';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
import { USER_TYPE } from '@plataforma/utils';
import { getAuth } from '@services/auth';

const getUser = () => {
  const broker = JSON.parse(localStorage.getItem('broker')) || {};
  return broker && broker.user ? broker.user : null;
};
const { userType } = getAuth();

const AppBarSearch = ({
  hideInput,
  hideFilter,
  backButton,
  inputProps,
  // customMenuItems,
  showJuntoLogo,
  backFunction,
  isConsultancy
}) => {
  const user = getUser();

  const goBackFunction = () => {
    let destinationUrl = isConsultancy
      ? getSessionItem('PLATAFORMA_PROCESSOS_LISTA')
      : getSessionItem('PLATAFORMA_PROCESSOS');

    /**
     * if the current page is different from the projects root url, redirect to process list
     */
    if (
      window.location.pathname !== '/' &&
      isConsultancy &&
      window.location.pathname !== '/list'
    ) {
      destinationUrl = window.location.origin;
    }

    window.location.href = destinationUrl;
  };

  return (
    <Header>
      <Container>
        {backButton ||
          (isConsultancy && (
            <BackButton onClick={backFunction || goBackFunction}>
              <BackButtonIcon />
              Voltar
            </BackButton>
          ))}

        <InputContainer>
          {!hideInput && <Search showFilter={!hideFilter} {...inputProps} />}
          {showJuntoLogo && <LogoJunto />}
        </InputContainer>
      </Container>

      {user && user.userName && userType !== USER_TYPE.consultancy && (
        <UserMenu
          user={user}
          // customItems={customMenuItems}
        />
      )}
    </Header>
  );
};

AppBarSearch.defaultProps = {
  backButton: false,
  hideInput: false,
  showJuntoLogo: false,
  hideFilter: true,
  inputProps: {
    value: ''
  },
  backFunction: undefined,
  isConsultancy: false
};

AppBarSearch.propTypes = {
  backButton: PropTypes.bool,
  hideInput: PropTypes.bool,
  isConsultancy: PropTypes.bool,
  showJuntoLogo: PropTypes.bool,
  hideFilter: PropTypes.bool,
  inputProps: PropTypes.shape({
    label: PropTypes.string
  }),
  backFunction: PropTypes.func,
  setFilter: PropTypes.number
};

export default memo(AppBarSearch);
